// extracted by mini-css-extract-plugin
export var header = "_cg-0";